import { Reducer } from "react";

import { LayoutInput } from '../../service/ServiceAPI';

// ----------------------------------------------------------
// LayoutInput
export type LayoutInputState = {
    layoutInput: LayoutInput,
}

const initialLayoutInputState: LayoutInputState = {
    layoutInput: {
        phename: " ",        //phename: "PHE100x20",
        operation: 'rate',
        //plateType: 'CB30', plateMaterial: 'ALLOY 316', coCurrent: true, 
        inTempSide1: '', volumeFlowSide1: '', fluidSide1: 'Oil ISO VG 46',
        //fluidConcSide1: '100',         
        inTempSide2: '', volumeFlowSide2: '', fluidSide2: 'Water', 
        //fluidConcSide2: '100',        
        
        //plateThickness: '0.31', fouling: '0.1', minNumberOfUnits: '1', maxNumberOfUnits: '10', 
    
        //numberOfPassesSide1: '1', numberOfChannelsSide1: '17', channelType1: 'H', 
        //numberOfPassesSide2: '1', numberOfChannelsSide2: '16', channelType2: 'H',
    
        //dissipatedHeat: '111',

        heatDissipation: '',
    
        responseData: ""
    }
}

type UpdateInputAction = {
    type: String,
    payload: LayoutInputState
}

export function updateLayoutInputAction(payload: LayoutInputState) {
    return { type: "DO_UPDATE_INPUT", payload: payload }
};

const layoutInputReducer : Reducer<LayoutInputState, UpdateInputAction> = (state: LayoutInputState = initialLayoutInputState, action: UpdateInputAction | any) => {
    switch(action.type) {
        case 'DO_UPDATE_INPUT':  // update redux with input data (e.g. we changed an input value)
            return {
                // nice description of "destructuring syntax", "Rest operator" and "Spread operator": https://mariusschulz.com/blog/object-rest-and-spread-in-typescript
                // article is also saved in "documentation" subdirectory of this project
                ...state, layoutInput: {...state.layoutInput, ...action.payload.layoutInput }  // spread/rest operator "...": take "state" and add the rest of type by setting member "layoutInput" explicitely
            };
        default: 
            return state;
    }
}

export default layoutInputReducer;

